import React, { useState, useEffect } from 'react';
import { reportsAPI } from '../services/api';
// ...existing code...
import './ManagementPages.css';

const ReportsPage = () => {
  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [reportType] = useState('dashboard');

  useEffect(() => { fetchReport(); }, []);

  const fetchReport = async () => {
    try {
      setLoading(true);
      setError(null);
      
      let data;
      if (reportType === 'dashboard') {
        data = await reportsAPI.getAdminDashboard();
      } else if (reportType === 'collections') {
        data = await reportsAPI.getCollectionsReport();
      } else if (reportType === 'performance') {
        data = await reportsAPI.getPerformanceReport();
      } else {
        data = await reportsAPI.getLedger();
      }
      
      setReport(data);
    } catch (err) {
      setError(err.message || 'Failed to load report');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Reports</h1>
        <p>Generate and view system reports</p>
      </div>

      {/* Show only Dashboard */}
      <div className="filters" style={{ marginBottom: '20px' }}>
        <button className={`filter-btn active`}>Dashboard</button>
      </div>

      {error && <div className="alert alert-error">{error}</div>}

      {loading ? (
        <div className="loader"></div>
      ) : report ? (
        <div className="report-container">
          {/* Dashboard Report */}
          {reportType === 'dashboard' && (
            <div>
              <div className="grid grid-4" style={{ marginBottom: '20px' }}>
                <div className="dashboard-card">
                  <div className="card-icon">👥</div>
                  <div className="card-content">
                    <div className="card-label">Total Agents</div>
                    <div className="card-value">{report.totalAgents || 0}</div>
                  </div>
                </div>
                <div className="dashboard-card">
                  <div className="card-icon">🏪</div>
                  <div className="card-content">
                    <div className="card-label">Total Retailers</div>
                    <div className="card-value">{report.totalRetailers || 0}</div>
                  </div>
                </div>
                <div className="dashboard-card">
                  <div className="card-icon">📋</div>
                  <div className="card-content">
                    <div className="card-label">Total Loans</div>
                    <div className="card-value">{report.totalLoans || 0}</div>
                  </div>
                </div>
                <div className="dashboard-card">
                  <div className="card-icon">💰</div>
                  <div className="card-content">
                    <div className="card-label">Collected</div>
                    <div className="card-value">₹{(report.totalCollected || 0).toLocaleString()}</div>
                  </div>
                </div>
              </div>

              <div className="grid grid-2" style={{ marginBottom: '20px' }}>
                <div className="dashboard-card">
                  <div className="card-icon">💵</div>
                  <div className="card-content">
                    <div className="card-label">Total Invested</div>
                    <div className="card-value">₹{(report.totalInvested || 0).toLocaleString()}</div>
                  </div>
                </div>
                <div className="dashboard-card">
                  <div className="card-icon">📊</div>
                  <div className="card-content">
                    <div className="card-label">Portfolio Value</div>
                    <div className="card-value">₹{(report.portfolioValue || 0).toLocaleString()}</div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Other report sections removed per request (only Dashboard visible) */}
        </div>
      ) : (
        <div className="no-data">No report data available</div>
      )}
    </div>
  );
};

export default ReportsPage;
